import {request} from "../utils/request";
import store from "../store/global";
import {TokenDto} from "./interfaces/token.dto";


export async function getToken(q: string): Promise<string> {
    if (!store.globalLoading)
        throw new Error('Is load!');
    const data: TokenDto = await request<TokenDto>('action_get_token.php', {
        method: 'get',
        params: {
            q
        },
        responseType: "json"
    });
    return data.token;
}

export async function getQuery(token: string): Promise<string> {
    const body: string = await request<string>('action_ai_gpt.php', {
        method: 'get',
        params: {
            token
        },
        responseType: "text"
    });

    let tx="";
    const b = body.split("\n");
    for (let i=0; i<b.length; i++) {
        if (b[i].slice(0, 5) === "data:") {
            if (b[i].slice(6) === "[DONE]") {
                break;
            }
            const data = JSON.parse(b[i].slice(6));
            if (data.choices[0].delta.content !== undefined) {
                tx = tx + data.choices[0].delta.content;
            }
        }
    }

    return tx;
}
